import { createSlice } from '@reduxjs/toolkit';

export const imagesSlice = createSlice({
	name: 'images',
	initialState: {
		value: null,
	},
	reducers: {
		setImages: (state, action) => {
			state.value = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setImages } = imagesSlice.actions;
export const selectImages = (state) => state.images.value;
export default imagesSlice.reducer;
